/**
 * Shared complaint-list navigation filters used from dashboard KPIs / sections.
 */

/** Active critical complaints (open through vendor-escalated). */
export const ACTIVE_CRITICAL_COMPLAINTS_FILTER = {
  severities: ['critical'],
  statuses: ['open', 'acknowledged', 'in_progress', 'escalated_to_vendor'],
  daysOpenFrom: '',
  daysOpenTo: '',
};
